import type { ProfileAddressFilters } from '@/entities/Address/model/types';
import { getExecutorAddressApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ExecutorAddressResponse, CreateExecutorAddressRequest, UpdateExecutorAddressRequest } from '@/core/generated/api';

/** Выполняет операции с адресами исполнителя */
export const executorAddressService = {
    /** Загружает адреса исполнителя */
    async getAllExecutorAddresses(
        executorId: string,
        filters: ProfileAddressFilters = {}
    ): Promise<ExecutorAddressResponse[]> {
        try {
            const response = await getExecutorAddressApi()
                .getAllExecutorAddresses({
                    ...filters,
                    executorId
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает адрес исполнителя */
    async getExecutorAddressById(id: string): Promise<ExecutorAddressResponse> {
        try {
            const response = await getExecutorAddressApi().getExecutorAddressById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт адрес исполнителя */
    async createExecutorAddress(
        data: CreateExecutorAddressRequest
    ): Promise<ExecutorAddressResponse> {
        try {
            const response = await getExecutorAddressApi().createExecutorAddress({ createExecutorAddressRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет адрес исполнителя */
    async updateExecutorAddress(
        data: UpdateExecutorAddressRequest
    ): Promise<ExecutorAddressResponse> {
        try {
            const response = await getExecutorAddressApi().updateExecutorAddress({ updateExecutorAddressRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Делает адрес исполнителя избранным */
    async setFavorite(id: string): Promise<void> {
        try {
            await getExecutorAddressApi().setExecutorAddressFavorite({ id });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Деактивирует адрес исполнителя */
    async deleteExecutorAddress(id: string, comment?: string): Promise<void> {
        try {
            await getExecutorAddressApi()
                .deleteExecutorAddress({
                    id,
                    deleteRequest: { comment }
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
